import React, { Component } from 'react';
import PropTypes from 'prop-types';
import signatureLogo from '../../../img/signature-logo-dark.png';
import ibslLogo from '../../../img/ibsl-logo-dark.png';

class Step0 extends Component {
  render () {
    return (
      <div className='registration__first'>
        <div className='registration__inner'>
          <h1 className='kilo'>Learn British Sign Language online at your own pace – <strong>whatever your goals and current level</strong></h1>
          <div className='registration__cta'>
            <a
              onClick={() => this.props.handleNextClick({})}
              className='registration__start registration__next button button--xl button--shadow button--full'>
                Start learning for free now
            </a>
            <p className='cta-info'>
              We'll help you pick the right course in the next step.
            </p>
            <p className='cta-info'>Not sure? <a className='cta-info__standout' href='/contact'>Ask an expert for help</a> or <a href='/courses'>view all courses</a></p>
            <img src={signatureLogo} alt='Signature logo' />
            <img src={ibslLogo} alt='IBSL logo' />
          </div>
        </div>
      </div>
    );
  }
}

Step0.propTypes = {
  handleNextClick: PropTypes.func.isRequired
};

export default Step0;



// WEBPACK FOOTER //
// ./src/components/CoursePicker/Step0/index.js